import { apiRequest } from '../../../lib/api-client.js';

/**
 * Shim de API pros componentes portados do super.old (web-v2).
 *
 * Os arquivos do old chamam `/api/v1/super/*` (server único). No super novo,
 * cada chamada vai pro servidor SELECIONADO via proxy `/api/servers/{id}/*`.
 * Este shim reescreve o path, então os componentes do old rodam quase sem
 * mudança (só trocam o import do `api` + Button/Modal/Badge pros do super).
 */
let selectedServerId: number | null = null;

export function setSelectedServer(id: number | null): void {
  selectedServerId = id;
}

function mapPath(path: string): string {
  if (selectedServerId == null) {
    throw new Error('Nenhum servidor selecionado (setSelectedServer não chamado).');
  }
  return path.replace(/^\/api\/v1\/super\//, `/api/servers/${selectedServerId}/`);
}

export const api = {
  get: <T>(path: string): Promise<T> => apiRequest<T>(mapPath(path)),
  post: <T>(path: string, body?: unknown): Promise<T> =>
    apiRequest<T>(mapPath(path), { method: 'POST', body }),
  patch: <T>(path: string, body?: unknown): Promise<T> =>
    apiRequest<T>(mapPath(path), { method: 'PATCH', body }),
  delete: <T>(path: string): Promise<T> => apiRequest<T>(mapPath(path), { method: 'DELETE' }),
};
